module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-14.48738e44.svg";